import { render, staticRenderFns } from "./LevelsClassroomsFilter.vue?vue&type=template&id=06fa7466&"
import script from "./LevelsClassroomsFilter.vue?vue&type=script&lang=js&"
export * from "./LevelsClassroomsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports